import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ExcelExportService, GridComponent } from '@syncfusion/ej2-angular-grids';
import { fadeInOut } from '../../shared/helpers/animations';
import { IFileMetadataMessage, IFileMetadataStats, IServiceError } from '../../shared/models/index';

@Component({
  selector: 'app-filedetails',
  templateUrl: './filedetails.component.html',
  styleUrls: ['./filedetails.component.scss'],
  providers: [ExcelExportService],
  animations: [fadeInOut],
  encapsulation: ViewEncapsulation.Emulated
})
export class FiledetailsComponent implements OnInit {

  public gridDateFormat: Object;
  fileDetailsStats: IFileMetadataStats;
  fileDetailsMessage: IFileMetadataMessage;
  // fileData = [];
  error: string;
  @Input() successData: IFileMetadataMessage[];
  @Input() rejectedData: IFileMetadataMessage[];

  resolverMessages: IFileMetadataMessage[];
  resolverStats: IFileMetadataStats[];

  @ViewChild('gridSuccess')
  public gridSuccess: GridComponent;

  @ViewChild('gridRejected')
  public gridRejected: GridComponent;

  constructor (private activatedRoute: ActivatedRoute, private router: Router) {

  }

  ngOnInit() {

    this.gridDateFormat = { type: 'dateTime', format: 'MM/dd/yyyy hh:mm a' };

    // Get data pre-populated in the Resolver or an serviceError object
    const fileData: any[] | IServiceError = this.activatedRoute.snapshot.data['fileData'];

    if (!fileData || fileData[1].length === 0) {

      this.error = 'File not found.';
      this.router.navigate(['/error', { message: 'File not found' }]);
    }

    if (fileData instanceof IServiceError) {
      this.error = fileData.friendlyMessage;
    } else {
      if (Array.isArray(fileData)) {
        this.resolverMessages = this.activatedRoute.snapshot.data['fileData'][0];
        this.resolverStats = this.activatedRoute.snapshot.data['fileData'][1];

        this.loadStats();
        this.loadMessages();
      }
    }
  }

  exportToExcel(success): void {

    if (success) {

      //this.gridSuccess.excelExport({ fileName: 'SuccessfulImportLog.xlsx' });
    }
    else {
      //this.gridRejected.excelExport({ fileName: 'FailedImportLog.xlsx'});
    }
  }

  documentClicked(id: string) {

  }

  loadStats(): void {
    this.fileDetailsStats = {
      importId: 0,
      fileName: '',
      fileUploadedBy: '',
      fileOutcome: '',
      importedSuccessfully: 0,
      outComeType: '',
      fileOutcomeCode: 0,
      rejected: 0,
      totalCount: 0,
      uploadDate: '',
    };

    if (this.resolverStats && this.resolverStats.length > 0) {

      // same data for all rows
      this.fileDetailsStats.importId = this.resolverStats[0].importId;
      this.fileDetailsStats.fileName = this.resolverStats[0].fileName;
      this.fileDetailsStats.fileUploadedBy = this.resolverStats[0].fileUploadedBy;
      this.fileDetailsStats.fileOutcome = this.resolverStats[0].fileOutcome;
      this.fileDetailsStats.fileOutcomeCode = this.resolverStats[0].fileOutcomeCode;
      this.fileDetailsStats.outComeType = this.resolverStats[0].outComeType;
      this.fileDetailsStats.uploadDate = this.resolverStats[0].uploadDate;

      //recalculate counts
      for (let i = 0; i < this.resolverStats.length; i++) {
        switch (this.resolverStats[i].outComeType) {
          case 'Error':
            this.fileDetailsStats.rejected += this.resolverStats[i].totalCount;
            break;
          case 'Passed':
            this.fileDetailsStats.importedSuccessfully += this.resolverStats[i].totalCount;
          default:
        }
        this.fileDetailsStats.totalCount = this.fileDetailsStats.importedSuccessfully + this.fileDetailsStats.rejected;
      }
    }
  }

  loadMessages(): void {

    if (this.resolverMessages && this.resolverMessages.length > 0) {

      this.successData = this.resolverMessages.filter(t => t.messageSeverity.toLowerCase() !== 'error');
      this.rejectedData = this.resolverMessages.filter(t => t.messageSeverity.toLowerCase() === 'error');
    } else {
      this.fileDetailsMessage = {
        documentId: '',
        itemType: '',
        keyFields: 'No files to display',
        message: '',
        messageDate: '',
        lineNumber: 0,
        messageSeverity: ''
      };

      this.resolverMessages.push(this.fileDetailsMessage);
      this.successData = this.resolverMessages;
    }
  }

  navigateToFileUpload() {
    // Navigate back without reloading the page.
    this.router.navigateByUrl('fileupload');
  }

  getCSSClasses() {
    let cssClasses;
    if (!this.error && this.fileDetailsStats) {
      cssClasses = {
        'success': this.fileDetailsStats.fileOutcomeCode === 1,
        'warning': this.fileDetailsStats.fileOutcomeCode === 2 || this.fileDetailsStats.fileOutcomeCode === 3,
        'error': this.fileDetailsStats.fileOutcomeCode === 4,
      }
    }
    return cssClasses;
  }
}
